import AdminLayout from '../../templates/AdminLayout';
import ClinicList from '../../UI/organisms/clinic/ClinicList';

const ClinicListPage = () => {
  return <AdminLayout title={'한의원 목록'} content={<ClinicList />} sideType={0} />;
};

export default ClinicListPage;
